// @ts-strict-ignore
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, lastValueFrom } from 'rxjs';

export async function extractError<T>(
  promise: Promise<T>,
): Promise<[null, T] | [HttpErrorResponse, null]> {
  try {
    const data = await promise;
    return [null, data];
  } catch (err) {
    return [err as HttpErrorResponse, null];
  }
}

export async function toPromise<T>(
  observable: Observable<T>,
): PromiseResult<T> {
  return extractError(lastValueFrom(observable));
}

export type PromiseResult<T> = Promise<[HttpErrorResponse | null, T]>;
